import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-echarts-header" }
const _hoisted_2 = { class: "home-echarts-header__title" }
const _hoisted_3 = { class: "home-echarts-header__controls" }

import { ref, reactive, onBeforeMount } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import { getCurrentMonthDateRange } from '@/utils/timeFormat'
import CosRangePickerMonth from '@/components/CosRangePickerMonth/index.vue'
import { zbuGetInvalidAnalysis } from '@/api/marketing/index'
import type { Ref, PropType } from 'vue'

const __default__ = { name: 'InvalidReasonEchart' }

interface ItemType {
  num: number
  invalidId: number
  invalidName: string
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String as PropType<string>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '437px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  }
},
  setup(__props) {

const props = __props

const spinning = ref(false)
const showECharts = ref(false)
const { currentDayOfMonth } = getCurrentMonthDateRange()
const queryForm = reactive({
  countDate: currentDayOfMonth
})
const getData = () => {
  spinning.value = true
  const params = { countDate: queryForm.countDate.split(' ')[0] }
  zbuGetInvalidAnalysis(params)
    .then((res) => {
      const data = res.data as unknown as ItemType[]
      if (data.length === 0) {
        showECharts.value = false
        initChart([])
      } else {
        showECharts.value = true
        initChart(data)
      }
    })
    .finally(() => {
      spinning.value = false
    })
}

const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>)
const initChart = (data: any[]) => {
  const colorArr = ['#3F97FF', '#FFB648', '#36C8E1', '#F58BEA', '#877CED']
  // 求和
  const total = data.reduce((a, b: ItemType) => a + b.num, 0)
  setOptions({
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      top: '5%',
      left: '5%'
    },
    series: [
      {
        name: '无效原因分析',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: true,
          position: 'center',
          color: '#4c4a4a',
          formatter: '{total|' + total + '}' + '\n\r' + '{active|总线索}',
          rich: {
            total: {
              fontSize: 24,
              fontFamily: '微软雅黑',
              fontWeight: 700,
              color: '#333333'
            },
            active: {
              fontFamily: '微软雅黑',
              fontSize: 12,
              color: '#666666',
              lineHeight: 30
            }
          }
        },
        labelLine: {
          show: false
        },
        data: data.map((item, index) => {
          return {
            value: item.num,
            name: item.invalidName,
            itemStyle: {
              color: colorArr[index % 5]
            }
          }
        })
      }
    ]
  })
}
onBeforeMount(getData)

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-echarts-wrap",
    style: _normalizeStyle({ width: __props.width, height: __props.height })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CosRangePickerMonth, {
          style: {"width":"220px"},
          startTime: queryForm.countDate,
          "onUpdate:startTime": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.countDate) = $event)),
          allowClear: props.allowClear,
          onChange: getData
        }, null, 8, ["startTime", "allowClear"])
      ])
    ]),
    _createVNode(_component_a_spin, {
      spinning: spinning.value,
      delay: 200
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "home-echarts-content"
        }, null, 512), [
          [_vShow, showECharts.value]
        ]),
        (!showECharts.value)
          ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
              key: 0,
              type: "nothing"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ], 4))
}
}

})